import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getPayment(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createPayment(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/payment" + pathname, body);
}

export async function updatePayment(
  pathname,
  body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/payment" + pathname, body);
}

export async function deletePayment(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/payment" + pathname + queryParams);
}
